import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  Paper,
  Link,
} from "@mui/material";
//import axios from "../../api/axiosInstance";
import axios from "axios";

import { GoogleOAuthProvider } from "@react-oauth/google";
import GoogleLoginButton from "../GoogleLoginButton";

const GOOGLE_CLIENT_ID =
  "939137695762-af03nno1ms1rljb4ljko8sdvl7jvgros.apps.googleusercontent.com";

const LoginForm = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  const [error, setError] = useState(null);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const response = await axios.post(
        "https://crm-backoffice.connvisor.com/wp-json/jwt-auth/v1/token",
        //"http://localhost/leads-backoffice/wp-json/jwt-auth/v1/token",
        {
          username,
          password,
        }
      );
      const { token, user_display_name, profile_image } = response.data;

      localStorage.setItem("crm_jwt_token", token);
      localStorage.setItem("profile_image", profile_image);

      localStorage.setItem("nice_name", user_display_name);

      //localStorage.setItem("crm_jwt_token", token);
      //sessionStorage.setItem("crm_jwt_token", token);

      if (onLogin) onLogin(token);
    } catch (err) {
      const message = err.response?.data?.message || "Login failed";
      setError(message);
    }
  };

  //{ token, user }

  const handleGoogleSuccess = ({ token, user }) => {
    // Persist your app JWT
    const profileImage = user.avatar;

    localStorage.setItem("crm_jwt_token", token);
    localStorage.setItem("profile_image", profileImage);
    localStorage.setItem("nice_name", user.name);

    // Store user profile if you need it
    //localStorage.setItem("jwt_token", JSON.stringify(user));
    // Navigate to app (replace with your router)
    //window.location.href = "l";
    if (onLogin) onLogin(token);
  };

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Box
        component="img"
        src="/images/connvisor.webp"
        sx={{ mb: 1 }}
        display={"block"}
        mx={"auto"}
      />

      <Box display="flex" justifyContent="center" alignItems="center">
        <Paper elevation={3} sx={{ p: 4, width: 360 }}>
          <Typography variant="h5" gutterBottom textAlign="center">
            Login to Connvisor Leads Manager
          </Typography>

          <form onSubmit={handleSubmit}>
            <TextField
              label="Username"
              fullWidth
              margin="normal"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <TextField
              label="Password"
              type="password"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
              }
              label="Remember this login for 30 days"
            />

            {error && (
              <Typography
                color="error"
                variant="body2"
                mt={1}
                mb={1}
                dangerouslySetInnerHTML={{ __html: error }}
              />
            )}

            <Button
              variant="contained"
              fullWidth
              type="submit"
              sx={{ mt: 2, mb: 1 }}
            >
              Login
            </Button>

            <GoogleLoginButton onSuccess={handleGoogleSuccess} />

            <Box sx={{ mt: 3 }} textAlign="center">
              <Link href="#" underline="hover">
                Forgot Password?
              </Link>
            </Box>
          </form>
        </Paper>
      </Box>
    </GoogleOAuthProvider>
  );
};

export default LoginForm;
